/* PM - status dot interactivo en mobile/touch (product cards).
   Minimo, scoped a .pm-card-status-dot, event delegation en document ->
   funciona con cards re-renderizadas (paginacion AJAX, quick add, Theme
   Editor) sin volver a bindear nada. Guard en window evita listeners
   duplicados si el script se vuelve a ejecutar. */
(function () {
  if (window.pmCardStatusDotInit) return;
  window.pmCardStatusDotInit = true;

  var OPEN_CLASS = 'is-open';

  function closeDot(dot) {
    dot.classList.remove(OPEN_CLASS);
    dot.setAttribute('aria-expanded', 'false');
  }

  function openDot(dot) {
    dot.classList.add(OPEN_CLASS);
    dot.setAttribute('aria-expanded', 'true');
  }

  function closeAll(except) {
    document
      .querySelectorAll('.pm-card-status-dot.' + OPEN_CLASS)
      .forEach(function (dot) {
        if (dot !== except) closeDot(dot);
      });
  }

  document.addEventListener('click', function (event) {
    var dot = event.target.closest('.pm-card-status-dot');

    if (!dot) {
      closeAll();
      return;
    }

    var wasOpen = dot.classList.contains(OPEN_CLASS);
    closeAll(dot);

    if (wasOpen) {
      closeDot(dot);
    } else {
      openDot(dot);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      closeAll();
    }
  });
})();
